import { defineComponent } from '../utils/alpine'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/all'
import { SplitText } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

export const HomepageHero = defineComponent(() => ({
  init() {
    const mm = gsap.matchMedia()
    const title = this.$refs.title
    const buttons = this.$refs.buttons?.querySelectorAll('a')
    const player = this.$refs.player
    const tl = gsap.timeline({ paused: true })

    if (!title || !buttons || !player) return

    const splitTitle = new SplitText(title, {
      type: 'lines,chars',
      mask: 'lines',
    })

    tl.from(splitTitle.chars, {
      yPercent: 110,
      ease: 'power3.out',
      stagger: 0.05,
      duration: 1.5,
    })

    tl.from(
      buttons,
      {
        yPercent: 15,
        opacity: 0,
        ease: 'power2.out',
        stagger: 0.1,
        delay: 0.3,
        duration: 1,
      },
      '-=1.5',
    )

    tl.from(
      player,
      {
        yPercent: 5,
        opacity: 0,
        ease: 'power2.out',
        delay: 0.3,
      },
      '-=1.5',
    )

    if ((window as any).preloaderComplete) {
      tl.play()
    } else {
      window.addEventListener('preloader:complete', () => {
        tl.play()
      })
    }
  },

  discard() {},
}))
